<template>
  <b-container>
    <FanEditProfileTabs :user="currentUser" />

    <b-row>
      <b-col>
        <h4>Your credit card information</h4>
      </b-col>
    </b-row>

    <b-row v-if="!hasBillingInfo">
      <b-col class="cc-info cc-missing">
        <i class="sl-icon-credit-card" />
        <LinkButton :u="true" @click="addCard">Add a credit card</LinkButton> to be able to make purchases and donate to artists.
      </b-col>
    </b-row>

    <b-row v-else>
      <b-col class="cc-info cc-present">
        Card linked to account:
          &nbsp;
          <i class="sl-icon-credit-card" /> {{ cardBrand }} <b>********{{ cardLast4 }}</b> exp <b>{{ cardExp }}</b>
          &nbsp;
        <LinkButton :u="true" @click="addCard">Update card</LinkButton>
        <LinkButton :u="true" v-b-modal.confirmRemoveCard>Remove card</LinkButton>
      </b-col>
    </b-row>

    <b-row class="headline">
      <b-col>
        <h4>Purchases</h4>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-table :items="items" :fields="fields" class="sb-table">
          <span slot="artist" slot-scope="data">
            <router-link :to=artistLink(data.value)>{{ data.value.name }}</router-link>
          </span>
        </b-table>
      </b-col>
    </b-row>

    <b-modal id="confirmRemoveCard"
             ref="confirmRemoveCard"
             title="Remove credit card"
             @ok="removeCard"
             centered>
      <div class="content">
        <p>
          Would you like to remove your credit card from Songback?
        </p>
        <p>
          You'll need to provide a credit card the next time you make a purchase or donation.
        </p>
      </div>
    </b-modal>

    <CreditCardLinked ref="ccLinked" />
  </b-container>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';

  i.sl-icon-credit-card {
    margin-right: 0.2em;
  }

  .cc-info {
    text-align: center;
    padding: 0.5em;
    margin: 0 0.5em 1em 0.5em;

    &.cc-missing {
      background-image: linear-gradient(93deg, $darkish-pink, $blue-purple);
    }

    &.cc-present {
      border: 2px solid #dc3681;
      border-image-source: linear-gradient(93deg, $darkish-pink, $blue-purple);
      border-image-slice: 2;
    }

    a {
      color: $white;
      text-decoration: underline;
    }
  }

  .headline {
    margin-top: 1em;
    margin-bottom: 1em;

    .search {
      flex: 0;
      flex-basis: 15em;
    }

    .timefilter, .typefilter {
      flex: 0;
    }
  }

</style>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import ProfileHero from '@/components/widgets/ProfileHero'
import FanEditProfileTabs from '@/components/widgets/FanEditProfileTabs'
import SearchBox from '@/components/widgets/SearchBox'
import LinkButton from '@/components/widgets/LinkButton'
import CreditCardLinked from '@/components/widgets/CreditCardLinked'

import askForCard from '@/utils/stripe'

import moment from '@/utils/moment'
import map from 'lodash/map'

import { mapGetters } from 'vuex'

export default {
  name: 'Home',
  components: {
    FontAwesomeIcon,
    SearchBox,
    FanEditProfileTabs,
    ProfileHero,
    LinkButton,
    CreditCardLinked
  },
  data () {
    return {
      stripeCheckout: null,
      fields: [
        {
          key: 'date',
          label: 'Date',
          class: 'text-center'
        },
        {
          key: 'title',
          label: 'Title'
        },
        {
          key: 'artist',
          label: 'Artist'
        },
        {
          key: 'type',
          label: 'Type',
          class: 'text-center'
        },
        {
          key: 'amount',
          label: 'Amount',
          class: 'text-center'
        }
      ],
      items: []
    }
  },
  computed: {
    hasBillingInfo () {
      return !!this.currentUser.stripe_customer_id
    },
    cardInfo () {
      if (!this.currentUser.stripe_customer_id) return {}
      return this.currentUser.stripe_customer_data.sources.data[0] || {}
    },
    cardBrand () {
      const card = this.cardInfo
      return card ? card.brand : ''
    },
    cardLast4 () {
      const card = this.cardInfo
      return card ? card.last4 : ''
    },
    cardExp () {
      const card = this.cardInfo
      return card ? (card.exp_month + '/' + card.exp_year) : ''
    },
    ...mapGetters('profile', ['currentUser'])
  },
  created () {
    this.getPayments()
  },
  mounted () {
    window.addEventListener('popstate', this.closeStripeDialog)
  },
  beforeDestroy () {
    window.removeEventListener('popstate', this.closeStripeDialog)
  },
  methods: {
    closeStripeDialog () {
      if (this.stripeCheckout) {
        this.stripeCheckout.cancel()
        this.stripeCheckout = null
      }
    },
    async addCard () {
      this.stripeCheckout = askForCard(this.$store)

      try {
        await this.stripeCheckout.finish
        this.$refs.ccLinked.show()
      } catch (e) {
        console.log('can\'t capture cc', e)
      }
    },
    removeCard () {
      this.$store.dispatch('payment/removeCard')
    },
    async getPayments () {
      this.items = map((await this.$store.dispatch('payment/listPayments')).results, r => {
        return {
          artist: r.artist,
          type: r.is_cancelled ? 'refunded' : r.type,
          title: r.description,
          date: moment(r.created_at).format('MM/DD/YYYY h:mm a'),
          amount: '$ ' + r.amount.toFixed(2)
        }
      })
    },
    artistLink (artist) {
      return {
        name: 'artist-about',
        params: {
          artistId: artist.id
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/fan/BillingInfo.vue